import { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import portalApi, { setPortalToken, formatErr } from "./portalApi";
import { Loader2, AlertCircle } from "lucide-react";

export default function PortalAuth() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [err, setErr] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) {
      setErr("Missing link token");
      return;
    }
    (async () => {
      try {
        const { data } = await portalApi.post("/portal/auth", { token });
        setPortalToken(data.token);
        nav("/portal", { replace: true });
      } catch (e) {
        setPortalToken(null);
        setErr(formatErr(e));
      }
    })();
  }, []);

  return (
    <div className="max-w-md mx-auto" data-testid="portal-auth">
      <div className="bg-white border border-slate-200 rounded-lg p-9 shadow-sm text-center">
        {!err ? (
          <>
            <Loader2 size={28} className="mx-auto animate-spin text-slate-400" />
            <p className="text-sm text-slate-500 mt-4">Signing you in securely…</p>
          </>
        ) : (
          <>
            <AlertCircle size={32} className="mx-auto text-red-500" />
            <h2 className="font-display font-bold text-lg mt-3 text-slate-900">Link not valid</h2>
            <p className="text-sm text-slate-600 mt-2">{err}</p>
            <Link
              to="/portal/login"
              className="inline-block mt-5 text-sm text-[#0F4C81] underline"
              data-testid="portal-back-to-login"
            >
              Request a new link
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
